enum Ownership {
    PERSONAL = 'PERSONAL',
    SHARED = 'SHARED',
}

export default Ownership;